import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af33ba9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-12" }
const _hoisted_24 = { class: "text-gray-600 fs-7" }
const _hoisted_25 = { class: "fw-semibold me-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", { class: "me-2" }, "{type}", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", { class: "me-2" }, "{area}", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", { class: "me-2" }, "{category}", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", { class: "me-2" }, "{propertyType}", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", { class: "me-2" }, "{price}", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "{size}", -1))
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_34 = {
  class: "col-lg-8 fv-row",
  style: {"height":"150px"}
}
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_39 = {
  class: "col-lg-8 fv-row",
  style: {"height":"150px"}
}
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_44 = {
  class: "col-lg-8 fv-row",
  style: {"height":"200px"}
}
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_49 = {
  class: "col-lg-8 fv-row",
  style: {"height":"200px"}
}
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_54 = { class: "col-lg-8 fv-row" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "row mb-12" }
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-12" }
const _hoisted_60 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_61 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Upload logos"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-6" }, null, -1))
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = { class: "form-text" }
const _hoisted_66 = {
  key: 0,
  class: "image-input-wrapper"
}
const _hoisted_67 = { class: "thumbnail-grid" }
const _hoisted_68 = ["src"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_73 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_74 = {
  class: "col-lg-8 fv-row",
  style: {"height":"150px"}
}
const _hoisted_75 = { class: "row mb-12" }
const _hoisted_76 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_77 = { class: "col-lg-12" }
const _hoisted_78 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_79 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Upload thumbnails"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-6" }, null, -1))
const _hoisted_81 = { class: "fv-plugins-message-container" }
const _hoisted_82 = { class: "fv-help-block" }
const _hoisted_83 = { class: "form-text" }
const _hoisted_84 = {
  key: 0,
  class: "image-input-wrapper"
}
const _hoisted_85 = { class: "thumbnail-grid" }
const _hoisted_86 = ["src"]
const _hoisted_87 = ["onClick"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_91 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_92 = {
  class: "col-lg-8 fv-row",
  style: {"height":"150px"}
}
const _hoisted_93 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_94 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_95 = { class: "indicator-label" }
const _hoisted_96 = { class: "indicator-progress" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_MonacoEditor = _resolveComponent("MonacoEditor")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'ads'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewAdsBrokerageConfig')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.configSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('brokerName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "brokerName",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('brokerName'),
                      modelValue: _ctx.brokerName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.brokerName) = $event)),
                      onInput: _ctx.onBrokerAgentChange
                    }, null, 8, ["placeholder", "modelValue", "onInput"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "brokerName" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('agentName')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "agentName",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('agentName'),
                      modelValue: _ctx.agentName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agentName) = $event)),
                      onInput: _ctx.onBrokerAgentChange
                    }, null, 8, ["placeholder", "modelValue", "onInput"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "agentName" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('slug')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "slug",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid bg-light",
                      placeholder: _ctx.translate('slug'),
                      modelValue: _ctx.slug,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.slug) = $event)),
                      readonly: ""
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "slug" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate('availableVariables')) + ":", 1),
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('titleEn')), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_MonacoEditor, {
                      language: "json",
                      theme: "vs-dark",
                      class: "w-100",
                      value: _ctx.titleEnContent,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.titleEnContent) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.translate('titleAr')), 1),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_MonacoEditor, {
                      language: "json",
                      theme: "vs-dark",
                      class: "w-100",
                      value: _ctx.titleArContent,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.titleArContent) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('descriptionEn')), 1),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_MonacoEditor, {
                      language: "json",
                      theme: "vs-dark",
                      class: "w-100",
                      value: _ctx.descriptionEnContent,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.descriptionEnContent) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate('descriptionAr')), 1),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_MonacoEditor, {
                      language: "json",
                      theme: "vs-dark",
                      class: "w-100",
                      value: _ctx.descriptionArContent,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.descriptionArContent) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate('phone')), 1),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "phone",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('phone')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_ErrorMessage, { name: "phone" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('userAvatars')), 1),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.logoThumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_61, [
                        _hoisted_62,
                        _createElementVNode("input", {
                          type: "file",
                          name: "logos",
                          accept: ".png, .jpg, .jpeg",
                          multiple: "",
                          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.previewLogos && _ctx.previewLogos(...args)))
                        }, null, 32)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_ErrorMessage, { name: "logos" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.translate('allowedFileTypes')), 1),
                    (_ctx.logoPreviews.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logoPreviews, (logo, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "thumbnail-container"
                              }, [
                                _createElementVNode("img", {
                                  src: logo,
                                  class: "thumbnail-image img-ads"
                                }, null, 8, _hoisted_68),
                                _createElementVNode("button", {
                                  class: "remove-button",
                                  onClick: ($event: any) => (_ctx.removeLogo(index)),
                                  type: "button"
                                }, _hoisted_71, 8, _hoisted_69)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.logoContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.translate('userAvatarsJson')) + " (" + _toDisplayString(_ctx.translate('preview')) + ") ", 1),
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_MonacoEditor, {
                          language: "json",
                          theme: "vs-dark",
                          class: "w-100",
                          value: _ctx.logoContent,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.logoContent) = $event)),
                          options: { readOnly: true }
                        }, null, 8, ["value"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.translate('adImages')), 1),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.thumbnailThumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("input", {
                          type: "file",
                          name: "thumbnails",
                          accept: ".png, .jpg, .jpeg",
                          multiple: "",
                          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.previewThumbnails && _ctx.previewThumbnails(...args)))
                        }, null, 32)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createVNode(_component_ErrorMessage, { name: "thumbnails" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.translate('allowedFileTypes')), 1),
                    (_ctx.thumbnailPreviews.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbnailPreviews, (thumbnail, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "thumbnail-container"
                              }, [
                                _createElementVNode("img", {
                                  src: thumbnail,
                                  class: "thumbnail-image img-ads"
                                }, null, 8, _hoisted_86),
                                _createElementVNode("button", {
                                  class: "remove-button",
                                  onClick: ($event: any) => (_ctx.removeThumbnail(index)),
                                  type: "button"
                                }, _hoisted_89, 8, _hoisted_87)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.thumbnailContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                      _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.translate('adImagesJson')) + " (" + _toDisplayString(_ctx.translate('preview')) + ") ", 1),
                      _createElementVNode("div", _hoisted_92, [
                        _createVNode(_component_MonacoEditor, {
                          language: "json",
                          theme: "vs-dark",
                          class: "w-100",
                          value: _ctx.thumbnailContent,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.thumbnailContent) = $event)),
                          options: { readOnly: true }
                        }, null, 8, ["value"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_94, [
                  _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_96, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_97
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}